var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8576 3H3.07986C2.49757 3 2 3.49757 2 4.07986C2 4.66215 2.49757 5.19132 3.07986 5.19132H20.8576C21.5035 5.22257 22 4.725 22 4.11146C22 3.49792 21.5035 3 20.8576 3ZM13.1111 16.4306V15.224H10.8889V16.4306L8.27431 19.0451C8.05729 19.2622 8.05656 19.6167 8.27358 19.8337L9.05622 20.6163C9.27324 20.8334 9.62844 20.8333 9.84546 20.6163L12 18.4618L14.1215 20.6149C14.3385 20.832 14.6938 20.832 14.9108 20.615L15.6934 19.8324C15.9104 19.6153 15.9097 19.2608 15.6927 19.0438L13.1111 16.4306Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.7777 15.2222H4.2222C3.61039 15.2222 3.11108 14.7257 3.11108 14.1111L3.07983 5.22256H5.33331V13.0003H18.6666V5.22256H20.8576L20.8889 14.1111C20.8889 14.7257 20.3889 15.2222 19.7777 15.2222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPresentation);
export default __webpack_public_path__ + "static/media/icon-presentation.c9b79ff3b13c9bca1472a158150a5551.svg";
export { ForwardRef as ReactComponent };